module.exports = __webpack_public_path__ + "img/title-2.7290e11b.png";